import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { INotification } from '../../../types/Notification';

declare type TActionTypes =
  | 'ENQUEUE_SNACKBAR'
  | 'CLOSE_SNACKBAR'
  | 'REMOVE_SNACKBAR';

export interface TNotificationActions {
  type: TActionTypes;
  notification: INotification;
  dismissAll: boolean;
  key: number;
}

export interface INotificationsState {
  notifications: TNotificationActions[];
}

const initialState: INotificationsState = {
  notifications: [],
};

const ephemeralNotificationVariants = ['default', 'success', 'info'];

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    enqueueSnackbar: (state: any, action: PayloadAction<any>) => {
      const notification = action.payload;
      if (
        notification.options &&
        ephemeralNotificationVariants.includes(notification.options.variant)
      ) {
        notification.options.persist = false;
      }
      state.notifications = [
        ...state.notifications,
        {
          key: new Date().getTime() + Math.random(),
          ...notification,
        },
      ];
    },
    closeSnackbar: (state: any, action: PayloadAction<number | undefined>) => {
      const key = action && action.payload ? action.payload : undefined;

      state.notifications = state.notifications.map(
        (notification: TNotificationActions) =>
          !key || notification.key === key
            ? { ...notification, dismissed: true }
            : { ...notification }
      );
    },
    removeSnackbar: (state: any, action: PayloadAction<any>) => {
      const key = action.payload;
      state.notifications = state.notifications.filter(
        (notification: TNotificationActions) => notification.key !== key
      );
    },
  },
});

export const { enqueueSnackbar, closeSnackbar, removeSnackbar } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
